import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";

@Component({
    selector: "modal-timecard-template",
    templateUrl: "./modal-timecard-template.component.html",
    standalone: false
})
export class ModalTimecardTemplateComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private templateService: TemplateService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;
    defaultOrderBy: any = "name";
    defaultReverseSort: any = false;
    bulkSelectedOptionKey: any;

    modalTitle: any;
    cancelText: any;

    showErrormsg: any = false;
    errorMsg: any = "";
    submitted: any = false;
    timecards: any = [];
    templateId: any;
    name: any = "";

    queryContainer: any;
    allTemplates: any = [];

    /*being passed from parent*/
    templates: any = null;
    buAccess: any;
    /*uptil here from parent*/

    getQueryContainer() {
        const query: any = this.templateService.getPayrollTemplateQuery();
        query.BUId = this.buAccess.businessUnitId;
        query.pageSize = 999;
        query.sortByColumn = "name";
        return {
            query: query,
        };
    }

    onCreate() {
        this.showErrormsg = false;
        this.errorMsg = "";
        this.submitted = true;
        if (this.validate()) {
            if (!this.hasTemplateNameUsed()) {
                const template = this.getNewTemplate();
                this.upsertTemplates(template);
            } else {
                this.showErrormsg = true;
                this.errorMsg = "Template with same name already exists";
                this.submitted = false;
            }
        } else {
            this.showErrormsg = true;
            this.errorMsg = "Template Name is required";
            this.submitted = false;
        }
    }

    /* append template*/
    onAppend() {
        this.submitted = true;
        if (this.validateAppendTemplate()) {
            const template = this.getAppendTemplate();
            this.upsertTemplates(template);
        } else {
            this.submitted = false;
            this.showErrormsg = true;
            this.errorMsg = "Select Template";
        }
    }

    /* get append template*/
    getAppendTemplate() {
        const currentTemplate = _.find(this.templates, (o) => {
            return o.id === this.templateId.id;
        });

        const template = {
            id: this.templateId.id,
            name: currentTemplate.name,
            businessUnit: {
                id: this.buAccess.businessUnitId,
            },
            isActive: true,
        };
        return template;
    }

    getTimesheetTemplates() {
        this.log.trace("Get Timesheet Template");
        this.queryContainer.query.isActive = "All";

        this.templateService.getTemplates(this.queryContainer.query).subscribe({
            next: (result) => {
              this.templates = result.reference.items;
              this.allTemplates = this.templates;
            },
            error: (err) =>
                this.log.showModalError(
                    "Unable to load the timesheet template at this time. Please try again later."
                ),
        });
    }

    /*upsert to create and add new timecards*/
    upsertTemplates(template) {
        this.templateService
            .upsertTemplate(template, this.timecards)
            .subscribe({
                next: (result) => {
                    this.log.trace("upsert templates successful");
                    //this.onSync.next();
                    this.onSync.next(''); //TODO: Revisit
                },
                error: (err) =>
                    this.log.error(
                        "upsert template encounterd an error " + err
                    ),
            });
        this.bsModalRef.hide();
    }

    getNewTemplate() {
        const template = {
            id: -1,
            name: this.name,
            businessUnit: {
                id: this.buAccess.businessUnitId,
            },
            isActive: true,
        };
        return template;
    }

    cancel() {
        this.log.trace("canceled modal");
        this.bsModalRef.hide();
    }

    validate() {
        if (_.trim(this.name).length <= 0) {
            return false;
        }
        return true;
    }

    validateAppendTemplate() {
        if (
            !this.templateId ||
            this.templateId === "" ||
            this.templateId <= 0
        ) {
            return false;
        }
        return true;
    }
    hasTemplateNameUsed() {
        return _.some(this.allTemplates, (o) => {
            return _.lowerCase(o.name) === _.lowerCase(this.name);
        });
    }
    ngOnInit() {
        this.onSync = new Subject();
        this.queryContainer = this.getQueryContainer();
        this.getTimesheetTemplates();
    }
}
